let pendingCapture: Promise<void> | undefined;
/** Auth waits only for this bounded click capture, never for advertising SDKs. */
export function waitForOpenAIAdClick(): Promise<void> { return pendingCapture ?? Promise.resolve(); }
/** Capture only the opaque ad click, after the shared privacy checks. No SDK or user data. */
export function captureOpenAIAdClick(): Promise<void> | undefined {
  try {
    let clickId = new URLSearchParams(window.location.search).get('oppref');
    // Router navigation may have removed the initial landing query before analytics starts.
    if (!clickId) {
      const entry = performance.getEntriesByType('navigation')[0];
      if (entry) clickId = new URL(entry.name).searchParams.get('oppref');
    }
    if (!clickId) return;
    if (pendingCapture) return pendingCapture;
    pendingCapture = fetch('/api/advertising/openai', {
      method:'POST',credentials:'same-origin',keepalive:true,headers:{'Content-Type':'application/json'},
      body:JSON.stringify({clickId}),signal:AbortSignal.timeout(3000),
    }).then(() => {}).catch(() => {}).finally(() => { pendingCapture = undefined; });
    return pendingCapture;
  } catch { /* Attribution availability never blocks the app. */ }
}
